import { Switch } from "antd";
import React, { useState } from "react";

export default function Toggle({
	item,
	readOnly,
	addData,
	setSubmitData,
	submitData,
	value: controlledValue,
	onValueChange,
}) {
	const [value, setValue] = useState(false);
	const submittedValue = submitData?.find((i) => i.key === item.key)?.value;
	const rawValue = typeof onValueChange === "function" ? controlledValue : submittedValue;
	const currentValue = addData
		? rawValue === true || rawValue === "true"
		: item?.value ?? value ?? "";

	return (
		<div style={item?.css}>
			<label
				htmlFor="toggle"
				className="form-label mx-2"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
			>
				{item?.title}
			</label>
			<Switch
				onChange={(e) => {
					setValue(e);
					if (typeof onValueChange === "function") {
						onValueChange(item.key, e);
					}
					if (addData) {
						setSubmitData((prev) => {
							// Remove existing item with same key if you want to replace it
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: e,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				value={currentValue}
				disabled={readOnly}
			/>
		</div>
	);
}
